import React from 'react';
import { Icon, HouseLine, Folder } from '@phosphor-icons/react';

import { SideNavMainBtn } from '..';
import { URL } from '../../../../constants';

const MainSideNav = () => {
  const pathname = window.location.pathname;

  const btns: {
    id: string;
    icon: Icon;
    label: string;
    url: string;
    onClick?: () => void;
  }[] = [
    {
      id: 'home',
      icon: HouseLine,
      label: 'Home',
      url: URL.HOME,
    },
    {
      id: 'projects',
      icon: Folder,
      label: 'Projects',
      url: URL.DASH_PROJECTS,
    },
  ];

  return (
    <div className="flex flex-col gap-4">
      {btns.map((btn) => (
        <SideNavMainBtn
          key={btn.id}
          id={btn.id}
          Icon={btn.icon}
          url={btn.url}
          onClick={btn.onClick}
          label={btn.label}
          isCurrent={!!btn.url && pathname === btn.url}
        />
      ))}
    </div>
  );
};

export default MainSideNav;
